/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Server_Errors_Authrequired1Inputs */

const he_server_errors_authrequired1 = /** @type {(inputs: Server_Errors_Authrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נדרש אימות`)
};

const en_server_errors_authrequired1 = /** @type {(inputs: Server_Errors_Authrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentication required`)
};

/**
* | output |
* | --- |
* | "Authentication required" |
*
* @param {Server_Errors_Authrequired1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const server_errors_authrequired1 = /** @type {((inputs?: Server_Errors_Authrequired1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Server_Errors_Authrequired1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_server_errors_authrequired1(inputs)
	return en_server_errors_authrequired1(inputs)
});
export { server_errors_authrequired1 as "server_errors_authRequired" }